import React from 'react';
import { Link } from 'react-router-dom';
import Logo from "../ui/Logo.jsx";

const Footer = () => {
  return (
    <footer className="bg-primary-900 text-white pt-12 pb-6">
      <div className="container">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div>
            <div className="flex items-center">
              <Logo isWhite={true} height={64} />
            </div>            <p className="text-sand-100 mb-4">Innovative Solutions for a Global Marketplace. All your project needs in one place.</p>
            {/* <p className="text-sand-100 mb-4 text-sm">With headquarters in Turkey and Singapore, serving 12 countries across the Middle East and Africa.</p> */}
            {/* <div className="flex space-x-4">
              <a href="https://linkedin.com/company/onepoint-solutions" target="_blank" rel="noopener noreferrer" className="text-sand-200 hover:text-white">
                <i className="fab fa-linkedin-in"></i>
              </a>
              <a href="https://twitter.com/onepointsol" target="_blank" rel="noopener noreferrer" className="text-sand-200 hover:text-white">
                <i className="fab fa-twitter"></i>
              </a>
              <a href="https://facebook.com/onepointsolutions" target="_blank" rel="noopener noreferrer" className="text-sand-200 hover:text-white">
                <i className="fab fa-facebook-f"></i>
              </a>
              <a href="https://instagram.com/onepoint_solutions" target="_blank" rel="noopener noreferrer" className="text-sand-200 hover:text-white">
                <i className="fab fa-instagram"></i>
              </a>
            </div> */}
          </div>
          
          <div>
            <h3 className="text-lg font-bold mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li><Link to="/" className="text-sand-200 hover:text-white">Home</Link></li>
              <li><Link to="/solutions" className="text-sand-200 hover:text-white">Solutions</Link></li>
              <li><Link to="/about" className="text-sand-200 hover:text-white">About Us</Link></li>
              <li><Link to="/portfolio" className="text-sand-200 hover:text-white">Portfolio</Link></li>
              <li><Link to="/contact" className="text-sand-200 hover:text-white">Contact</Link></li>
            </ul>
          </div>
            <div>
            <h3 className="text-lg font-bold mb-4">Solution Categories</h3>
            <ul className="space-y-2">
              <li><Link to="/solutions/" className="text-sand-200 hover:text-white">Pumping Solutions</Link></li>
              <li><Link to="/solutions/" className="text-sand-200 hover:text-white">Piping Solutions</Link></li>
              <li><Link to="/solutions/" className="text-sand-200 hover:text-white">Valves & Controls</Link></li>
            </ul>
          </div>
          
          <div>
            <h3 className="text-lg font-bold mb-4">Contact Us</h3>
            <ul className="space-y-2">
              <li className="flex items-start">
                <i className="fas fa-map-marker-alt mt-1 mr-3 text-accent"></i>
                <span className="text-sand-200">İvedik OSB, 1122. Cd. Maxivedik İş Merkezi No:20/4, 06378 Yenimahalle/Ankara</span>
              </li>
              <li className="flex items-center">
                <i className="fas fa-phone mr-3 text-accent"></i>
                <a href="tel:+905379236439" className="text-sand-200 hover:text-white">+905379236439</a>
              </li>
              <li className="flex items-center">
                <i className="fas fa-envelope mr-3 text-accent"></i>
                <a href="mailto:onepoint@onepointtr.com" className="text-sand-200 hover:text-white">onepoint@onepointtr.com</a>
              </li>
            </ul>
          </div>
        </div>
        
        <div className="border-t border-primary-700 mt-10 pt-6">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <p className="text-sand-200 text-sm mb-4 md:mb-0">© 2025 One Point Industrial. All rights reserved.</p>
            <div className="flex space-x-6">
              <Link to="" className="text-sand-200 hover:text-white text-sm">Privacy Policy</Link>
              <Link to="/" className="text-sand-200 hover:text-white text-sm">Terms of Service</Link>
              <Link to="/" className="text-sand-200 hover:text-white text-sm">Sitemap</Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;